import { render } from "./ReportCard.vue?vue&type=template&id=2095bed4&scoped=true&ts=true"
import script from "./ReportCard.vue?vue&type=script&lang=ts"
export * from "./ReportCard.vue?vue&type=script&lang=ts"

import "./ReportCard.vue?vue&type=style&index=0&id=2095bed4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2095bed4"]])

export default __exports__